import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ParkProduct } from "@unleashed/models/ParkProduct";

export interface BulkProductState {
  sharedFields: ParkProduct | null;
  selectedProductTypeIndex: number;
  savedProductTypeIndex: number | null; // Track which product type the saved fields are for
}

const initialState: BulkProductState = {
  sharedFields: null,
  selectedProductTypeIndex: 0, // Default to Membership
  savedProductTypeIndex: null,
};

export const BulkProductSlice = createSlice({
  name: "bulkProduct",
  initialState,
  reducers: {
    setSharedFields: (state, action: PayloadAction<{ product: ParkProduct; productTypeIndex: number }>) => {
      state.sharedFields = action.payload.product;
      state.savedProductTypeIndex = action.payload.productTypeIndex;
    },
    setSelectedProductType: (state, action: PayloadAction<number>) => {
      state.selectedProductTypeIndex = action.payload;
    },
    clearSharedFields: (state) => {
      state.sharedFields = null;
      state.selectedProductTypeIndex = 0; // Reset to Membership on clear
      state.savedProductTypeIndex = null;
    },
  },
});

export const { setSharedFields, setSelectedProductType, clearSharedFields } = BulkProductSlice.actions;
